module.exports = __webpack_public_path__ + "842c42cfda035ef86917677ba8b8fdae.jpg";